export const COMING_SOON = "coming soon";

export type CreditBoxReport = {
    id: string;
    companyId: number;
    type: ReportType;
    createdAt: string;
    status: string;
    rating: string | null;
};

export enum ReportType {
    TALCOTT = "talcott_credit_box_v1",
    PEAK_ROCK = "peakrock_investor_test",
}

export enum InvestorName {
    TALCOTT = "Talcott",
    PEAK_ROCK = "Peak Rock",
}

export enum InvestorTestRating {
    TRUE = "TRUE",
    FALSE = "FALSE",
}

export enum CreditBoxStatus {
    Pending = "PENDING",
    Started = "STARTED",
    Success = "SUCCESS",
    Failure = "FAILURE",
}

export enum CreditBoxResult {
    PASS = "PASS",
    FAIL = "FAIL",
}

export type CreditBoxTask = {
    status: CreditBoxStatus;
    taskId: string;
};

export type prospectiveValues = {
    label: string;
    fieldType: string;
    value: string | number;
};

export type CreditBoxMeta = {
    displayMsg?: string;
    totalCreditBoxes?: number;
    totalOpportunities?: number;
    passFailSummary?: CreditBoxRunResults[];
    numPassingCreditBoxes?: number;
    numFailingCreditBoxes?: number;
    passingSummary?: CreditBoxRunResults[];
    presignedS3Url?: string;
};

export type CreditBoxRunResults = {
    investorName: string;
    creditBoxName: string;
    creditBoxId: string;
    icmId?: string;
    companyName?: string;
    oppotunityId?: string;
    score: number;
    status: CreditBoxRunStatus;
};

export enum CreditBoxRunStatus {
    PASS = "PASS",
    FAIL = "FAIL",
}

export type CreditBoxRunPayload = {
    creditBoxUuids?: string[];
    icmCompanies?: string[];
    sfdcOpportunities?: string[];
    prospectiveValues?: prospectiveValues[];
    testCreditBox?: Record<string, any>;
};

export type CreditBoxesResultsPayload = {
    creditBoxIds?: string[];
    opportunityName?: string;
    icmId?: string;
    icmUuid?: string;
    sfdcOpportunityIds?: string[];
    score?: string;
};

export type CreditBoxesResultsResponse = {
    numRecords: number;
    presignedXlsxUrl: string;
    xlsxSize: number;
};

export type CreditBoxMinimal = {
    id: string;
    name: string;
    latest?: string;
};

export type CreditBoxInvestorMap = {
    investor: string;
    creditBoxes: CreditBoxMinimal[];
};

export type CreditBoxOpportunityMap = {
    name: string;
    id: string;
    status?: string;
};

export enum CreditBoxSearchType {
    INVESTORS = "investors",
    OPPORTUNITIES = "opportunities",
}

export type CreditBoxesPaginatedResponse<T> = {
    items: T[];
    total: number;
    page: number;
    size: number;
    pages: number;
};

export const PAGE_SIZE = 1000;

export type CreditBoxCriteriaDetail = {
    comment: string;
    operator: string;
    featureName: string;
    opportunityValue: number | string | null;
    creditBoxValue: number | string;
    creditBoxScore: number | null;
    creditBoxBestPossibleScore: number;
};

export type CreditBoxDetailBlock = {
    scoreComboOperator?: string;
    comment?: string;
    blockScores?: number;
    blockIdealScores?: number;
    blockBestPossibleScores?: number;
    normalizedScores?: number;
    blockValueType?: string;
    details?: CreditBoxCriteriaDetail[];
    [key: string]: any;
};

export type CreditBoxResultDetail = {
    creditBoxId: string;
    creditBoxName: string;
    sfdcOpportunityId: string;
    icmId: string | null;
    icmUuid: string | null;
    createdAt: string;
    updatedAt: string;
    s3Location: string;
    score: number;
    details: CreditBoxDetailBlock[];
};

export type CreditBoxResultsResponse = {
    creditBoxResultDetails: CreditBoxResultDetail[];
};

export const HUM_CREDIT_BOXES = [
    "06851878-cdbf-7f09-8000-1706f9d5bb0b",
    "0686387b-3b5a-7966-8000-8eda73642004",
    "0686387b-3d41-776b-8000-47d8cee7195c",
    "0686387b-3794-7425-8000-88d25deae4f2",
] as const;
